export enum RegionChannel {
  CREATE = 'region::create',
  EDIT = 'region::patch',
  DELETE = 'region::delete',
}
